import { Action } from 'redux'

import ClientFlightInterface from '../../interfaces/client/Flight'

import { RECEIVE_FLIGHT } from '../../actions/flights/receiveFlight'

export interface FlightsState {
  byId: {
    [id: string]: ClientFlightInterface
  }
  allIds: string[]
}

export interface FlightsAction extends Action {
  flight: ClientFlightInterface
}

export const initialState: FlightsState = {
  byId: {},
  allIds: [],
}

export default (
  state = initialState,
  action: FlightsAction = {
    type: '',
    flight: {
      flightId: '',
      flightNumber: '',
      route: '',
      origin: '',
      originCode: '',
      destination: '',
      destinationCode: '',
      arrivalDate: '',
      arrivalDay: '',
      arrivalTime: '',
      departureDate: '',
      departureDay: '',
      departureTime: '',
      travelClassSeatCounts: [],
    },
  }
) => {
  switch (action.type) {
    case RECEIVE_FLIGHT:
      const currentFlight = state.byId[action.flight.flightId]

      if (currentFlight) {
        return {
          ...state,
          byId: {
            ...state.byId,
            [currentFlight.flightId]: {
              ...currentFlight,
              ...action.flight,
            },
          },
        }
      }

      return {
        ...state,
        byId: {
          ...state.byId,
          [action.flight.flightId]: action.flight,
        },
        allIds: [...state.allIds, action.flight.flightId],
      }
    default:
      return state
  }
}
